import styled from "styled-components";

export const AppWrap = styled.div`
    a {
        text-decoration: none;
        color: unset;
    }
`